import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SEO from '../common/SEO';
import HeaderFour from '../common/header/HeaderFour';
import ContactSection from '../component/contact/ContactSection';
import FooterOne from '../common/footer/FooterOne';

const ServicePage = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const services = t('services.items', { returnObjects: true }) || [];
  const pages = t('services.pages', { returnObjects: true }) || {};
  const page = pages[slug];
  const service = services.find((item) => item.slug === slug);

  if (!service || !page) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <SEO title={`${page.title} | ${t('meta.homeTitle')}`} description={page.lead} />
      <main className="main-wrapper">
        <HeaderFour />
        <section className="section section-padding mutawir-service">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-7 col-xl-7">
                <span className="mutawir-tagline">{t('services.tagline')}</span>
                <h1 className="mutawir-service__title">{page.title}</h1>
                <p className="mutawir-service__lead">{page.lead}</p>
                {Array.isArray(page.intro) &&
                  page.intro.map((paragraph, index) => (
                    <p key={index} className="mutawir-service__paragraph">
                      {paragraph}
                    </p>
                  ))}
                {Array.isArray(page.capabilities) && page.capabilities.length > 0 && (
                  <div className="mutawir-service__capabilities">
                    {page.capabilities.map((capability, index) => (
                      <div className="mutawir-card mutawir-card--service" key={index}>
                        <h3 className="mutawir-card__title">{capability.title}</h3>
                        {Array.isArray(capability.items) && capability.items.length > 0 && (
                          <ul className="mutawir-service__list">
                            {capability.items.map((item, itemIndex) => (
                              <li key={itemIndex}>{item}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="col-lg-5 col-xl-4 offset-xl-1">
                <aside className="mutawir-service__sidebar">
                  <h2 className="mutawir-service__sidebar-title">{service.title}</h2>
                  {Array.isArray(page.outcomes) && page.outcomes.length > 0 && (
                    <div>
                      <h3 className="mutawir-service__sidebar-heading">{t('services.keyOutcomes')}</h3>
                      <ul className="mutawir-service__outcomes">
                        {page.outcomes.map((outcome, outcomeIndex) => (
                          <li key={outcomeIndex}>{outcome}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {page.cta && page.cta.href && (
                    <a className="axil-btn btn-fill-primary" href={page.cta.href}>
                      {page.cta.label}
                    </a>
                  )}
                </aside>
              </div>
            </div>
          </div>
        </section>
        <ContactSection />
      </main>
      <FooterOne variant="mutawir" />
    </>
  );
};

export default ServicePage;
